import React, { Fragment } from "react";
import PropTypes from "prop-types";
import benefitsJobProfileType from "../types/benefitsJobProfileType";
import {
  SectionTitle,
  Label,
  CheckBoxInput,
  CheckBoxLabel,
  CheckBoxesGroup,
  CheckBoxesGroupItem,
  Indicator,
} from "../styles/edit-form-styles";

const BenefitsAndRequirements = (props) => {
  const { jobProfile, inputOnChange, benefitsOnChange } = props;
  const { degreeRequired, visaSponsorship, considerRelocation, benefitIds } =
    jobProfile;

  return (
    <Fragment>
      <SectionTitle>Benefits & Requirements</SectionTitle>
      <Label htmlFor="must-haves">Benefits</Label>
      <CheckBoxesGroup>
        <CheckBoxesGroupItem>
          <CheckBoxLabel>
            <CheckBoxInput
              type="checkbox"
              name="benefit"
              checked={benefitIds.indexOf(0) > -1}
              id={0}
              value="Car"
              onChange={benefitsOnChange}
            />
            Car
            <Indicator />
          </CheckBoxLabel>
        </CheckBoxesGroupItem>
        <CheckBoxesGroupItem>
          <CheckBoxLabel>
            <CheckBoxInput
              type="checkbox"
              name="benefit"
              id={1}
              checked={benefitIds.indexOf(1) > -1}
              value="Pension"
              onChange={benefitsOnChange}
            />
            Pension
            <Indicator />
          </CheckBoxLabel>
        </CheckBoxesGroupItem>
        <CheckBoxesGroupItem>
          <CheckBoxLabel>
            <CheckBoxInput
              type="checkbox"
              name="benefit"
              id={2}
              checked={benefitIds.indexOf(2) > -1}
              value="Parking"
              onChange={benefitsOnChange}
            />
            Parking
            <Indicator />
          </CheckBoxLabel>
        </CheckBoxesGroupItem>
        <CheckBoxesGroupItem>
          <CheckBoxLabel>
            <CheckBoxInput
              type="checkbox"
              name="benefit"
              id={4}
              value="Commission"
              checked={benefitIds.indexOf(4) > -1}
              onChange={benefitsOnChange}
            />
            Commission
            <Indicator />
          </CheckBoxLabel>
        </CheckBoxesGroupItem>
        <CheckBoxesGroupItem>
          <CheckBoxLabel>
            <CheckBoxInput
              type="checkbox"
              name="benefit"
              id={5}
              value="Gym Membership"
              checked={benefitIds.indexOf(5) > -1}
              onChange={benefitsOnChange}
            />
            Gym Membership
            <Indicator />
          </CheckBoxLabel>
        </CheckBoxesGroupItem>
        <CheckBoxesGroupItem>
          <CheckBoxLabel>
            <CheckBoxInput
              type="checkbox"
              name="benefit"
              id={6}
              value="Healthcare/Dental"
              checked={benefitIds.indexOf(6) > -1}
              onChange={benefitsOnChange}
            />
            Healthcare/Dental
            <Indicator />
          </CheckBoxLabel>
        </CheckBoxesGroupItem>
        <CheckBoxesGroupItem>
          <CheckBoxLabel>
            <CheckBoxInput
              type="checkbox"
              name="benefit"
              id={7}
              value="Other"
              checked={benefitIds.indexOf(7) > -1}
              onChange={benefitsOnChange}
            />
            Childcare
            <Indicator />
          </CheckBoxLabel>
        </CheckBoxesGroupItem>
        <CheckBoxesGroupItem>
          <CheckBoxLabel>
            <CheckBoxInput
              type="checkbox"
              name="benefit"
              id={8}
              value="Childcare"
              checked={benefitIds.indexOf(8) > -1}
              onChange={benefitsOnChange}
            />
            Other
            <Indicator />
          </CheckBoxLabel>
        </CheckBoxesGroupItem>
      </CheckBoxesGroup>
      <Label htmlFor="requirements">Requirements</Label>
      <CheckBoxesGroup>
        <CheckBoxesGroupItem>
          <CheckBoxLabel>
            <CheckBoxInput
              type="checkbox"
              name="degreeRequired"
              id="degree-required"
              checked={degreeRequired}
              onChange={inputOnChange}
            />
            Degree Required
            <Indicator />
          </CheckBoxLabel>
        </CheckBoxesGroupItem>
        <CheckBoxesGroupItem>
          <CheckBoxLabel>
            <CheckBoxInput
              type="checkbox"
              name="visaSponsorship"
              id="visa-sponsorship"
              checked={visaSponsorship}
              onChange={inputOnChange}
            />
            Visa Sponsorship
            <Indicator />
          </CheckBoxLabel>
        </CheckBoxesGroupItem>
        <CheckBoxesGroupItem>
          <CheckBoxLabel>
            <CheckBoxInput
              type="checkbox"
              name="considerRelocation"
              id="consider-relocation"
              checked={considerRelocation}
              onChange={inputOnChange}
            />
            Consider Relocation
            <Indicator />
          </CheckBoxLabel>
        </CheckBoxesGroupItem>
        <CheckBoxesGroupItem>
          <CheckBoxLabel>
            <CheckBoxInput
              type="checkbox"
              name="relocationAssistance"
              id="relocation-assistance"
            />
            Relocation Assistance
            <Indicator />
          </CheckBoxLabel>
        </CheckBoxesGroupItem>
      </CheckBoxesGroup>
    </Fragment>
  );
};

BenefitsAndRequirements.propTypes = {
  inputOnChange: PropTypes.func.isRequired,
  benefitsOnChange: PropTypes.func.isRequired,
  jobProfile: benefitsJobProfileType.isRequired,
};

export default BenefitsAndRequirements;
